import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';

import { Grid, IconButton, Card } from '@material-ui/core';
import { VisibilityOff, Search} from '@material-ui/icons';
import ButtonComponent from '@components/Shared/Buttons/Button';
import Button from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd,  Input, Spin, Radio, Switch } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { FormatDate } from '@utils/formats';

import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';

import Services, {
  IGetAllIntencoesTable,
  IRequestIntencao,
} from './services';

const columnsLabel = {
  id: 'ID',
  descricao: 'Descrição',
  dataCadastro: 'Data cadastro',
};

const SolicitacaoIntencaoMissa: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IGetAllIntencoesTable[]>([]);
  const [formref] = Form.useForm();

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingCreateHorario, setLoadingCreateHorario] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(false);



  async function loadGetAllIntencoes() {
    setLoading(true);
    await api
      .get('/api/TipoIntencaoMissa/GetAllTipoIntencaoMissa')
      .then(response => {
        const items = response.data;

        const itemData: IGetAllIntencoesTable[] = items.map((item: any) => ({
          id: item.id,
          descricao: (
            <div style={{ opacity: item.statusAtivo === 0 ? 0.4 : 1 }}>
              {item.descricao}
            </div>
          ),
          dataCadastro: (
            <div style={{ opacity: item.statusAtivo === 0 ? 0.4 : 1 }}>
              {FormatDate(item.dataCadastro)}
            </div>
          ),
          statusAtivo: item.statusAtivo,
        }));


        setData(itemData);
        setLoading(false);
      })
      .catch(() => {
        enqueueSnackbar(`Erro ao carregar a lista`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  }


  async function onSubmit(values: any) {
    setLoadingCreate(true);
    console.log(values);

    const createSolicitacao: IRequestIntencao = {
      descricao: values.descricao,
    };

    const service = new Services();
    const { error } = await service.CreateIntencao(createSolicitacao);

    setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      clearDados();
      loadGetAllIntencoes();  
      setHabilitarBotao(false);
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  const loadDesativarIntencao = async (id: number) => {
    const services = new Services();

    const recuseSolicitacaoResponse = await services.DesativarIntencao({ id });

    if (!recuseSolicitacaoResponse.error) {
      enqueueSnackbar(`Desativado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      // Recarrega apenas a lista, sem reload da página
      loadGetAllIntencoes();
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  };


  const clearDados = () => {
    formref.setFieldsValue({
      descricao: '',
    });
  };


  useEffect(() => {
    loadGetAllIntencoes();
    window.document.title = 'CRM - Intenções';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        {/* FORMULARIO  */}
        <Grid item lg={12} sm={12} xs={12}>
          <Spin
            size="large"
            spinning={loadingCreate}
            tip="Enviando dados..."
          >
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError={true}
              onFinish={onSubmit}
              labelAlign="left"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              requiredMark={false}
              initialValues={{

                dia_semana: '',
                horario: '',
              }}
            >

              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* Lista dos horários cadastrados  */}
                <Grid container item lg={6} sm={6} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 550,  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
                    >

                      <TableCustomKeysNoPagination
                        loading={loading}
                        columns={[columnsLabel]}
                        FieldsBold={['descricao']}
                        data={data}
                        keys={[
                          'id',
                          'descricao',
                          'dataCadastro',
                        ]}
                        ActionHeader={'Desativar'}
                          Actions={[
                            {
                              Button: (item: IGetAllIntencoesTable & { statusAtivo?: number }) => (
                                <Grid
                                  container
                                  justifyContent="center"
                                  style={{
                                    opacity: item.statusAtivo === 0 ? 0.4 : 1, 
                                  }}
                                >
                                  <IconButton
                                    onClick={() => loadDesativarIntencao(item.id)} 
                                  >
                                    <VisibilityOff />
                                  </IconButton>
                                </Grid>
                              ),
                            },
                          ]}
                      />
                    </Grid>
                  </Card>
                </Grid>

                {/* Novo cadastro de horário  */}
                <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item lg={6} md={6} xs={5} style={{ paddingLeft: 250, paddingRight: 5, alignSelf: 'end' }}>
                      <ButtonComponent
                        fullWidth
                        style={{ height: 46, borderRadius: 5}}
                        color={"secondary"}
                        onClick={() => {
                          setHabilitarBotao(true)
                        }}
                      >
                        Nova intenção
                      </ButtonComponent>
                    </Grid>

                    <Grid container>
                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="descricao" label="Intenção"
                          rules={[
                            {
                              required: true,
                              message: 'Adicione uma intenção',
                            },
                          ]}
                        >
                         <Input   disabled={habilitarBotao !== true} />
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          disabled={habilitarBotao !== true}
                          onClick={clearDados}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                          disabled={habilitarBotao !== true}
                        >
                          Salvar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencaoMissa;
